// Maps an ApiError to a shared/i18n string id, never rendering a raw server
// message (root CLAUDE.md). `knownCodes` is the specific, small allow-list
// of codes the calling screen actually expects (e.g. OTP verify only ever
// throws OTP_INCORRECT/OTP_NOT_REQUESTED/OTP_TOO_MANY_ATTEMPTS) — the same
// discipline as admin/src/pages/LoginPage.jsx's own CREDENTIAL_ERROR_IDS
// map, generalized into one small helper instead of copy-pasted per screen.
// An error code outside that allow-list, or a genuine network failure
// (ApiError.status === 0, see shared/api/client.js), falls back to the
// generic 'error.INTERNAL_ERROR'/'error.NETWORK_ERROR' ids — both already
// exist in shared/i18n/strings.js.

import { ApiError } from 'shared/api/client.js';

export function mapApiErrorId(err, knownCodes = []) {
  if (!(err instanceof ApiError)) {
    return 'error.INTERNAL_ERROR';
  }
  if (err.status === 0) {
    return 'error.NETWORK_ERROR';
  }
  if (knownCodes.includes(err.code)) {
    return `error.${err.code}`;
  }
  return 'error.INTERNAL_ERROR';
}

export default mapApiErrorId;
